export const tooltipDefaults = Object.freeze({
	placement: "top",
	mouseEnterDelay: 0.2,
	destroyTooltipOnHide: true,
});
